import * as PIXI from "pixi.js";
 


//this is the blueprint of any scene

export class Scene {
    container: PIXI.Container

    constructor() {
        this.container = new PIXI.Container();



    }

    create() { }

    update() { }

    pause() { } // just pause

    stop() { } //stop and reset

    destroy() { }

    resize(newWidth:number,newheight:number){}

   

    remove() {
        // console.log('remove')
        // this.destroy();
        this.stop()
        this.container.destroy();
    }
}